module.exports = __webpack_public_path__ + "static/invoice-94334ca89dea19bd5a05ba53c6547dc7.jpg";